import { FC } from 'react';
import Select, { CSSObjectWithLabel, Options, SingleValue } from 'react-select';

type Option = {
    value: string;
    label: string;
};

interface IProps {
    value: string;
    setValue: (value: string) => void;
    label?: string;
    options: Options<Option> | undefined;
    dataCy?: string;
}

// TODO: @JavFr @javic91 review and make select inputs Standard
export const AlternativeSelect: FC<IProps> = ({ value, setValue, label, options, dataCy }) => {
    // eslint-disable-next-line eqeqeq
    const selectedValue = options?.find((option) => option.value == value);

    const handleSelectValue = (selectedOption: SingleValue<Option>) => setValue(selectedOption?.value || '');

    return (
        <div className="w-full">
            <div className="block">
                {label && (
                    <label className="text-xs font-semibold !font-['Poppins'] text-surface-emphasis-high tracking-[0.2px]">
                        {label}
                    </label>
                )}
            </div>
            <div data-cy={dataCy}>
                <Select
                    value={selectedValue}
                    onChange={handleSelectValue}
                    options={options}
                    className="text-sm border-gray-100 rounded !h-[32px] w-full"
                    classNames={{
                        singleValue: () => 'selectedValue',
                    }}
                    styles={{
                        control: (baseStyles) =>
                            ({
                                ...baseStyles,
                                minHeight: '32px !important',
                                height: '32px !important',
                                borderRadius: '4px',
                                borderColor: 'rgb(207 216 220) !important',
                                cursor: 'pointer',
                            } as CSSObjectWithLabel),
                        menu: (baseStyles) =>
                            ({
                                ...baseStyles,
                                zIndex: 35,
                            } as CSSObjectWithLabel),
                        valueContainer: (baseStyles) =>
                            ({
                                ...baseStyles,
                                minHeight: '32px !important',
                                height: '100% !important',
                            } as CSSObjectWithLabel),
                        input: (baseStyles) =>
                            ({
                                ...baseStyles,
                                opacity: '0',
                                height: '100% !important',
                            } as CSSObjectWithLabel),
                        singleValue: (baseStyles) =>
                            ({
                                ...baseStyles,
                                height: '100% !important',
                                paddingTop: '4px',
                                color: '#263238',
                                fontSize: '14px',
                            } as CSSObjectWithLabel),
                        option: (baseStyles, state) =>
                            ({
                                ...baseStyles,
                                cursor: 'pointer',
                                backgroundColor: state.isSelected ? '#1473F7' : 'white',
                                '&:hover': {
                                    backgroundColor: state.isSelected ? '#1473F7' : '#E3EEFE',
                                },
                                color: state.isSelected ? 'white' : '#263238',
                                fontSize: '1rem',
                            } as CSSObjectWithLabel),
                        indicatorSeparator: () => ({
                            display: 'none',
                        }),
                        dropdownIndicator: () => ({
                            color: 'rgba(38, 50, 56, 0.6)',
                            marginBottom: '2px',
                            marginRight: '9px',
                        }),
                    }}
                />
            </div>
        </div>
    );
};
